// src/pages/CourseTime/components/slides/layouts/AnalysisFrameworkSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import NoDataFallback from '../common/NoDataFallback.comp';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: TemplateAnalysisFramework
const AnalysisFrameworkSlide = ({ slide, renderSpokenText, skipTitleSpeech, themeColor }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  const fw = slide.FrameworkData;
  const accent = themeColor || '#3D5AFE';
  if (!fw) {
    return (
      <NoDataFallback
        slide={slide}
        skipTitleSpeech={skipTitleSpeech}
        renderSpokenText={renderSpokenText}
        renderContent={renderContent}
      />
    );
  }
  return (
    <S.SlideDescription>
      <S.SlideTitle>
        <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
      </S.SlideTitle>
      {fw.framework_name && (
        <S.PointText style={{ fontWeight: 600, marginBottom: 8 }}>
          {renderContent('fw_name', fw.framework_name)}
        </S.PointText>
      )}
      <ul>
        {(fw.principles || []).map((p, idx) => (
          <li key={idx}>
            <S.PointText>{renderContent(`fw_p_${idx}`, p)}</S.PointText>
          </li>
        ))}
      </ul>
      {fw.application_note && (
        <div style={{ background: `${accent}10`, padding: '10px 14px', borderRadius: 8, marginTop: 8 }}>
          <S.PointText><strong>How to apply:</strong> {renderContent('fw_apply', fw.application_note)}</S.PointText>
        </div>
      )}
    </S.SlideDescription>
  );
};

export default AnalysisFrameworkSlide;
